module.exports = __webpack_public_path__ + "static/media/image-1.d49b76a9.jpg";